const { UPDATE_ROULIST, GET_ROULIST } = require('../../constant');

const updateRouListAction = (rouList) => ({
  type: UPDATE_ROULIST,
  data: rouList,
});

const getRouListAction = () => ({
  type: GET_ROULIST,
});

export { updateRouListAction, getRouListAction };
